
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormGroupDirective } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ISubscription, Subscription } from 'rxjs/Subscription';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subject } from 'rxjs';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpService } from '../../../services/http/http.service';

@Component({
  selector: 'app-invitation-form',
  templateUrl: './invitation-form.component.html',
  styleUrls: ['./invitation-form.component.scss']
})
export class InvitationFormComponent implements OnInit {
  jobApplication: FormGroup;
  spinner = false;
  data: any = {};
  locRegex = new RegExp('^[a-zA-Z ]*$');
  cid;
  digitExp = '^([1-9])+[0-9]*$';
  nameExp = '[a-zA-Z ]*$';
  // gender = "";
  graduationYear = [];
  currentQualification;
  qualificationArray = ['BE', 'ME', 'MCA', 'BTECH', 'MTECH', 'MSC', 'Others'];
  currentYear = new Date().getFullYear();
  qualification = new FormControl(null, [Validators.required, Validators.pattern(this.nameExp), this.noWhitespaceValidator]);
  interviewMessage = "";
  interviewAddress = "";
  referralType = "";
  constructor(private fb: FormBuilder, public route: ActivatedRoute,
    public snackBar: MatSnackBar, public dialog: MatDialog,
    private router: Router, private spinnerService: Ng4LoadingSpinnerService,
    private httpService: HttpService,
    private snackbar: MatSnackBar) {
    this.route.queryParams.subscribe(params => {
      this.cid = params['cid'];
      this.referralType = params['referralType'];

    })
  }

  ngOnInit() {
    this.getCampaingData();
    for (var i = 2011; i <= this.currentYear; i++) {
      this.graduationYear.push(i);
    }
    this.jobApplication = this.fb.group({
      fullName: [null, Validators.compose([Validators.required, Validators.minLength(2),
      Validators.pattern('[a-zA-Z ]*$')])],
      email: [null, Validators.compose([Validators.required, Validators.maxLength(50),
      Validators.pattern('^([a-zA-Z0-9][.-]?)+@([a-zA-Z0-9]+[.-]?)*[a-zA-Z0-9][.][a-zA-Z]{2,3}$')])],

      phoneno: [null, Validators.compose([Validators.required, Validators.pattern('[6-9]{1}[0-9]{9}')])],

      permanantLocation: [null, Validators.compose([Validators.required, Validators.pattern(this.digitExp)])],
      currentLocation: [null, Validators.compose([Validators.required, Validators.pattern(this.digitExp)])],
      currentYear: [null, [Validators.required]],
      currentQualification: [null, [Validators.required]],
      gender: [null, [Validators.required]],
      referralName: [null, [Validators.required, Validators.pattern('[a-zA-Z ]*$')]],
      referralContactNumber: [null, Validators.compose([Validators.required, Validators.pattern('[6-9]{1}[0-9]{9}')])]
    });
    this.inputAutoCompleteDisable();
  }

  inputAutoCompleteDisable() {
    setTimeout(() => {
      const inputs = document.getElementsByTagName('input');
      for (let index = 0; inputs[index]; index++) {
        const inputElement = inputs[index];
        inputElement.setAttribute('autocomplete', 'off');
      }
    }, 500);
  }

  getErrorMessage(controlName: string, alias: string) {
    const control = this.jobApplication.controls[controlName];

    if (control.errors) {
      if (control.errors.required) {
        return alias + ' is required';
      }
      if (control.errors.minlength) {
        return alias + ' should have at least ' + control.errors.minlength.requiredLength + ' characters';
      }
      if (control.errors.pattern) {
        return 'Invalid ' + alias.toLowerCase();
      }
      if (control.errors.maxlength) {
        return alias + ' should not have more than ' + control.errors.maxlength.requiredLength + ' characters';
      }
      if (control.errors.min) {
        return alias + ' should be greater than ' + control.errors.min.min;
      }
      if (control.errors.max) {
        return alias + ' can not be greater than ' + control.errors.max.max;
      }
    }
  }
  getErrorForqualification() {
    return this.qualification.hasError('required') ? 'Qualification Cannot be blank' :
      this.qualification.hasError('pattern') ? 'Qualification must contains alphabet only' :
        this.qualification.hasError('whitespace') ? 'Please provide valid full name' :
          '';
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  applyJob(data) {
    this.data = {
      fullName: data.fullName.trim(),
      emailId: data.email.trim(),
      phoneNumber: data.phoneno.trim(),
      permanentPinCode: data.permanantLocation,
      currentPinCode: data.currentLocation,
      graduationYear: data.currentYear,
      qualification: this.currentQualification == 'Others' ? this.qualification.value : data.currentQualification,
      gender: data.gender,
      campaignId: this.cid,
      referralName: this.referralType ? data.referralName : '',
      referralContactNumber: this.referralType ? data.referralContactNumber : ''
    }
  

    if (data != undefined) {
      this.spinnerService.show();
      var contentBody = { url: "/register", body: this.data }
      this.httpService.httpPost(contentBody, false).subscribe(response => {
       
        this.spinnerService.hide();
        this.openSnackBar(response["message"]);
        this.router.navigate(['thank-you'])

      }, error => {
       
        this.spinnerService.hide();

        this.openSnackBar(error.error.message);
      })
    }
  }
  openSnackBar(message: string) {
    if (message == null || message == "" || message == undefined) {
      this.snackbar.open("Network Error", null, {
        duration: 5000
      });
    }
    else {
      this.snackbar.open(message, null, {
        duration: 5000
      });
    }
  }
  getCampaingData() {
    localStorage.removeItem('interviewAddress');
    localStorage.removeItem('interviewMessage');
    
    let contentBody = { url: '/campaignpurpose/' + this.cid };
    this.httpService.httpGetWithoutAuth(contentBody).subscribe(response => {
      // console.log('response', response);
      localStorage.setItem("interviewAddress", response.interviewAddress)
      localStorage.setItem("interviewMessage", response.interviewMessage)
    
      this.interviewMessage = localStorage.getItem('interviewMessage');
      this.interviewAddress = localStorage.getItem('interviewAddress');

    }, error => {
      // console.log('error ', error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    });
  }

}
